export default __webpack_public_path__ + "static/media/child_404.d39d30d9.png";